import Repository from '../axios'

const resource = "/admin/tasks";

export default {
  getTasks() {
    return Repository.get(`${resource}`)
  },
  getTasksByYou() {
    return Repository.get(`${resource}/assigned`)
  },
  getTask(id) {
    return Repository.get(`${resource}/${id}`)
  },
  createTask(payload) {
    return Repository.post(`${resource}`, payload)
  },
  deleteTask(id) {
    return Repository.delete(`${resource}/${id}`)
  },
  updateTask(id, payload) {
    return Repository.put(`${resource}/${id}`, payload)
  },
  statusChange(id, status) {
    return Repository.put(`/admin/task/${id}/${status}`)
  },
};
